import { render } from "./Contact.page.vue?vue&type=template&id=6c5c2d8c&ts=true"
import script from "./Contact.page.vue?vue&type=script&lang=ts"
export * from "./Contact.page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__